import { render, staticRenderFns } from "./CompareVersions.vue?vue&type=template&id=07fe0654"
import script from "./CompareVersions.vue?vue&type=script&lang=js"
export * from "./CompareVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports